import { render, staticRenderFns } from "./coagencyDetail.vue?vue&type=template&id=37554176&scoped=true&"
import script from "./coagencyDetail.vue?vue&type=script&lang=js&"
export * from "./coagencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./coagencyDetail.vue?vue&type=style&index=0&id=37554176&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37554176",
  null
  
)

export default component.exports